<template>
  <div class="footer-bg">
    Copyright © 2020 Inspiringhk. All rights reserved.
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer-bg {
  background: #85c358;
  height: 37px;
  width: 100%;
  margin: 0 auto;
  line-height: 37px;
  text-align: center;
  color: #ffff;
  font-size: 13px;
  z-index: 1;
  position: relative;
}
</style>
